export default {
  init() {
    const wcFormWrapperSelectors = [
      '.woocommerce-form-login',
      '.woocommerce-form-register',
      '.woocommerce-ResetPassword',
      '.woocommerce-EditAccountForm',
    ]

    // Set input placeholders in login page, because there are no relevant hooks.
    // @see woocommerce/templates/myaccount/form-login.php
    $('input[type="text"], input[type="password"], input[type="email"], input[type="tel"]', wcFormWrapperSelectors.join(', '))
      .each(function (i, el) {
        const $el = $(el)
        // Find the label
        const $label = $(`label[for="${$el.attr('id')}"]`)

        // Remove asterisks from labels (which later become placeholders)
        $label.find('.required').remove()

        let text = $label.text()

        if (text.length === 0) {
          return
        }

        // Remove this (we add it under the legend see below)
        // text = text.replace('(leave blank to leave unchanged)', '')

        // Set the placeholder as the label
        $el.attr('placeholder', text)
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce_account.js